import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';
import { ReportService } from 'src/services/report.service';

interface StampHQSummary {
	CompanyId: number;
	CompanyCode: string;
	TotalIn: number;
	TotalOut: number;
	Total: number;
}

@Component({
	selector: 'app-stamp-hqsummary',
	standalone: false,
	templateUrl: './stamp-hqsummary.component.html',
	styleUrl: './stamp-hqsummary.component.scss'
})
export class StampHQSummaryComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	protected enums = inject(Enums);
	private reportService = inject(ReportService);
	protected sharedService = inject(SharedService);
	protected companyService = inject(CompanyService);
	protected restApi = inject(RestApiService);
	protected constructApi = inject(ConstructAPI);

	protected companyGroup: number;
	protected companyId: number;
	protected startDate: Date;
	protected endDate: Date;
	protected reportList: StampHQSummary[] = [];
	protected companyList: Company[] = [];
	protected searchText: string;
	readonly displayedColumns: string[] = ['CompanyCode', 'TotalIn', 'TotalOut', 'Total'];
	protected routeSubscription: any;

	protected dataSource = new MatTableDataSource<StampHQSummary>();

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	async ngOnInit() {
		this.routeSubscription = this.activatedRoute.paramMap.subscribe(async params => {
			this.companyGroup = +params.get('companyGroupId');
			this.startDate = params.get('startDate') == undefined ? undefined : new Date(params.get('startDate'));
			this.endDate = params.get('endDate') == undefined ? undefined : new Date(params.get('endDate'));

			this.companyList = await this.companyService.getAllCompanies({ groupId: this.companyGroup });
			await this.getCompanyStampHQTransactionDetails();

			console.log(this.dataSource);
		});
	}

	async getCompanyStampHQTransactionDetails() {
		var reportList: StampHQSummary[] = [];
		const startDateStr = this.startDate.toISOString();
		const endDateStr = this.endDate.toISOString();

		const xhttp =
			this.companyGroup == undefined ?
				this.restApi.getRequest(this.constructApi.getTransactionDetails(startDateStr, endDateStr, [this.enums.STAMP_HQ]))
			:	this.restApi.getRequest(this.constructApi.getTransactionDetails(startDateStr, endDateStr, [this.enums.STAMP_HQ], this.companyGroup));

		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);
				jsonArray.forEach(json => {
					var company = this.companyList.find(com => Number(com.ID) == Number(json.companyId));
					var report = {
						CompanyId: json.companyId,
						CompanyCode: company.CompanyCode,
						TotalIn: Number(json.in) || 0,
						TotalOut: Number(json.out) || 0,
						Total: Number(json.total) || 0
					};
					this.reportList.push(report);
				});
			}

			this.setDatasource();
		};
	}

	setDatasource() {
		//make report list as the datasource
		this.dataSource = new MatTableDataSource<StampHQSummary>(this.reportList);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	applyFilter(event: any) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}
}
